import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { marcasModuleName, marcasStorage } from "../shared/data.service";
import { Marca } from "../shared/marca.model";
import { MarcaNavigationService } from "../shared/marca-navigation.service";
import { MarcaApiService } from "../shared/marca-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { editRoute, newRouteFemale } from "../../../shared/services/data.service";
import { MarcasService } from "../shared/marca.service";

@Component({
  template: require('./marca-form.component.html'),
  styles: [require('./marca-form.component.css')]
})
export class MarcaFormComponent implements OnInit {
  marcasModule: any = marcasModuleName;
  formObject: any = new Marca();
  actionTitle: string;
  submitted: boolean = false;
  btnSaveDisabled: boolean = false;

  form: FormGroup;
  marca = new FormControl('', Validators.required);
  ativo = new FormControl('');

  private returnToOtherForm: boolean = false;
  private otherForm: string;
  private responseMarca: any;

  constructor(
    private _route: ActivatedRoute,
    private _marcaNavigationService: MarcaNavigationService,
    private _marcaApiService: MarcaApiService,
    private _marcasService: MarcasService,
    private _utilService: UtilService,
    private _autocompleteService: AutoCompleteService,
    private _fb: FormBuilder
  ) {
    this.form = _fb.group({
      ativo: this.ativo,
      marca: this.marca
    });
  }

  ngOnInit() {
    this.isNewAutoComplete();
  }

  clickGoToList() {
    this.goToList();
  }

  clickCancel() {
    this.toLeaveHere();
  }

  onSubmit(evt: any) {
    this.submitted = true;
    if(evt.valid) {
      this.btnSaveDisabled = true;
      var object:Marca = this._utilService.cloneObject(this.formObject);

      if (this.formObject.id) {
        this.onEditMarca(object);
      } else {
        this.onAddMarca(object);
      }
    }
  }

  private onAddMarca(object: Marca) {
    this._marcaApiService.onPost(object, this.onDone);
  }

  private onEditMarca(object: Marca) {
    this._marcaApiService.onPut(object, this.onDone);
  }

  private onDone = (function (Response: any) {
    if (!Response.error)  {
      this.responseMarca = Response;
      if (this.formObject.id) {
        this._utilService.swalMessageEditSuccess();
      } else {
        this._utilService.swalMessageAddSuccess();
      }

      this.toLeaveHere();
    } else {
      this.btnSaveDisabled = false;
      this._utilService.swalMessageWarningCustom(Response.error);
    }
  }.bind(this));

  private getObject(id: number) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.formObject = Response;
        this.setModelToForm();

      } else {
        this._utilService.swalMessageWarningCustom('Nenhuma marca encontrada com este id.');
        this.toLeaveHere();
      }
    }.bind(this));

    this._marcaApiService.onGetById(id, onDone);
  }

  private testSession() {
    var id: number;
    var session: any = this._marcasService.getSessionStorage();
    this._marcasService.clearSessionStorage();

    if (session) {
      this.formObject = session;
      id = session.id;
      this.setModelToForm();
    } else {
      id = +this._route.snapshot.params['id'];
      if (id) {
        this.setEditNormal(id);
      } else {
        this.setNewNormal();
      }
    }

    this.setActionTitle(id);
  }

  private setActionTitle(id: number) {
    if (id) {
      this.actionTitle = editRoute;
    } else {
      this.actionTitle = newRouteFemale;
    }
  }

  private setEditNormal(id: number) {
    this.getObject(id);
  }

  private setNewNormal() {
    //se tiver alguma configuração inicial de um cadastro novo
  }

  private setEditSession() {
    //qndo retornou para continuar a edição
  }

  private setNewSession() {
    //qndo retornou para continuar o cadastro
  }

  private isNewAutoComplete() {
    var newAutoComplete: any = this._autocompleteService.getSessionStorage(marcasStorage);
    if (newAutoComplete) {
      this.returnToOtherForm = true;
      this.otherForm = newAutoComplete.form;
      this.formObject.marca = newAutoComplete.marca;

      this.setActionTitle(this.formObject.id);
    } else {
      //retornando de um cadastro
      this.testSession();
    }
  }

  private setModelToForm() {

  }

  private goToList() {
    this._marcaNavigationService.goToList();
  }

  private toLeaveHere() {
    if (this.returnToOtherForm) {
      this._marcasService.returnToOtherForm(this.otherForm, this.responseMarca);
    } else {
      this.goToList();
    }
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/marcas/marca-form/marca-form.component.ts
 **/